import { Modal, Form, Input } from "antd";
import { useEffect } from "react";

export default function EstadoFinancieroForm({ open, onCancel, onSubmit, initialValues }) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        onSubmit(values);
        form.resetFields();
      });
  };

  return (
    <Modal
      open={open}
      title={initialValues ? "Editar Estado" : "Nuevo Estado"}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Estado"
          name="estado"
          rules={[
            { required: true, message: "Campo obligatorio" }
          ]}
        >
          <Input placeholder="Ej: Entregado" />
        </Form.Item>
      </Form>
    </Modal>
  );
}